import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Texarkana, AR?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Texarkana can take 2–6 months, especially during peak travel seasons. For railroad professionals with international training assignments, college students with study-abroad deadlines, and mission team members with fixed departure dates, that timeline is simply not viable.",
  },
  {
    q: "Can railroad and logistics professionals in Texarkana get a passport quickly?",
    a: "Absolutely. Railroad and logistics industry professionals are one of our most common client types in the Texarkana area. International training programs, safety certification courses, and supplier meetings in Canada, Mexico, and Europe often arrive with 2–4 week notice. We provide expedited passport renewals and new applications with processing as fast as 2–9 business days — well within a typical railroad industry assignment timeline.",
  },
  {
    q: "Can Texarkana College or TAMUT students get passports fast for study abroad?",
    a: "Yes. Both Texarkana College and Texas A&M University-Texarkana send students abroad for study programs, service-learning trips, and international internships. Many are first-time passport applicants who discover their need after program acceptance. First-time applicants require an in-person acceptance clerk visit — we guide students through the exact Texarkana acceptance facilities, required forms, and timeline so they do not miss their program departure.",
  },
  {
    q: "Can Ark-La-Tex church mission teams get passports quickly?",
    a: "Yes — mission team passport processing is one of our most common Texarkana requests. Miller County and Bowie County churches send teams to Mexico, Guatemala, Honduras, East Africa, and Southeast Asia annually, often with participant lists finalized 2–4 weeks before departure. We help mission leaders manage the process for multiple team members simultaneously, including first-time applicants who have never needed a passport before.",
  },
  {
    q: "How far is Texarkana from the nearest passport agency?",
    a: "Texarkana sits between two regional passport agencies — Little Rock (approximately 140 miles east) and Dallas-Fort Worth (approximately 170 miles southwest). Getting an appointment at either requires documented urgent travel and the agency's appointment calendar. Fast Passport Center eliminates both drives. Start your order online, ship your documents overnight from Texarkana, and we handle the submission through our reserved courier access.",
  },
  {
    q: "Can Texarkana, TX residents use this service?",
    a: "Yes — absolutely. Fast Passport Center serves all U.S. citizens regardless of which side of the state line they live on. Texarkana, TX residents can use either the AR-side or TX-side acceptance facilities for new applications, then ship their documents overnight to us for expedited processing. The service is the same regardless of your state.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Texarkana travelers start online and ship their documents via overnight courier. There is no Fast Passport Center office in Texarkana, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from any FedEx or UPS location in the Ark-La-Tex area.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function TexarkanaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Texarkana and Ark-La-Tex travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden">
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`text-white text-sm transition-transform duration-200 ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}